import { render, staticRenderFns } from "./product-variants-table.vue?vue&type=template&id=61e44a92&scoped=true"
import script from "./product-variants-table.vue?vue&type=script&lang=js"
export * from "./product-variants-table.vue?vue&type=script&lang=js"
import style0 from "./product-variants-table.vue?vue&type=style&index=0&id=61e44a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_72a858df71aeaca8538e59a65db64572/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e44a92",
  null
  
)

export default component.exports